<template>
    <div>
        <vx-card id="timeshiftChannelDiv"  class="vs-con-loading__container xl:w-1/3 lg:w-1/2 w-full">
            <div v-if="!editEnabled">
                <table class="simple-table mt-6" >
                    <tr>
                        <td class="font-semibold">Channel:</td>
                        <td>{{ timeshiftChannel.worker_channel_name }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Channel Worker:</td>
                        <td>{{ timeshiftChannel.channel_worker_name }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Recording Worker:</td>
                        <td>{{ timeshiftChannel.worker_name }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Retention days:</td>
                        <td>{{ timeshiftChannel.retention_days }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Override link:</td>
                        <td v-if="timeshiftChannel.override_link">
                            <vs-chip color="success">Yes</vs-chip>
                        </td>
                        <td v-else>
                            <vs-chip color="danger">No</vs-chip>
                        </td>
                    </tr>
                    <tr v-if="timeshiftChannel.override_link">
                        <td class="font-semibold">Link:</td>
                        <td>{{ timeshiftChannel.link }}</td>
                    </tr>
                    <tr>
                        <td class="font-semibold">Enabled:</td>
                        <td v-if="timeshiftChannel.enabled">
                            <vs-chip color="success">Yes</vs-chip>
                        </td>
                        <td v-else>
                            <vs-chip color="danger">No</vs-chip>
                        </td>
                    </tr>
                </table>
            </div>
            <div v-else>
                <vs-checkbox class="mt-3" v-model="editObject['enabled']">Enabled</vs-checkbox>
                <p class="mt-6">Retention days</p>
                <vs-input v-model="editObject['retention_days']" class="w-full"></vs-input>
                <p class="mt-6">Recording Worker</p>
                <vs-select autocomplete class="w-full" v-model="editObject['worker_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in workers" />
                </vs-select>
                <div class="vx-row">
                    <div class="vx-col w-4/12 mt-6">
                        <vs-checkbox class="mt-6" v-model="editObject['override_link']">Override link</vs-checkbox>
                    </div>
                    <div class="vx-col w-8/12">
                        <p class="mt-6">Link</p>
                        <vs-input :disabled="!editObject['override_link']" v-model="editObject['link']" class="w-full"></vs-input>
                    </div>
                </div>
            </div>

            <vs-divider/>

            <vs-button style="float: left" icon-pack="feather" icon="icon-edit" v-if="!editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = true">Edit</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-save" v-if="editEnabled" color="success" class="mt-6; mr-1" @click="saveTimeshiftChannel">Save</vs-button>
            <vs-button style="float: left" icon-pack="feather" icon="icon-x" v-if="editEnabled" color="warning" class="mt-6; mr-1" @click="editEnabled = false">Cancel</vs-button>
            <vs-button style="float: right" icon-pack="feather" icon="icon-trash-2" v-if="editEnabled" color="danger" class="mt-6; mr-1" @click="removeTimeshiftChannel">Remove</vs-button>
            <div style="clear: both"></div>
        </vx-card>
    </div>
</template>
<script>
export default {
    data(){
        return {

            timeshiftChannel: {
                worker_channel_name: 0,
                worker_name: '',
                retention_days: 0,
                override_link: false,
                link: '',
                enabled: false,
            },

            workers: [],

            editEnabled: false,
            editObject: {},

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#timeshiftChannelDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get('/api/management/v1/timeshift/' + this.$route.params.id)
            loadPromise.then(function(response) {
                thisIns.timeshiftChannel = response.data;
                thisIns.editObject = JSON.parse(JSON.stringify(response.data));
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })

            const workersPromise = this.$http.get('/api/management/v1/worker/?type=adopted')
            workersPromise.then(function(response) {
                thisIns.workers = response.data
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })

            Promise.all([loadPromise, workersPromise]).finally(function() {
                thisIns.$vs.loading.close('#timeshiftChannelDiv > .con-vs-loading')
            })
        },
        saveTimeshiftChannel() {
            this.$vs.loading({
                container: '#timeshiftChannelDiv',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const savePromise = this.$http.put('/api/management/v1/timeshift/' + this.$route.params.id, {
                enabled: this.editObject.enabled,
                retention_days: Number(this.editObject.retention_days),
                worker_id: Number(this.editObject.worker_id),
                override_link: this.editObject.override_link,
                link: this.editObject.link,
            })

            savePromise.then(function() {
                thisIns.$printSuccess('Timeshift channel saved')
                thisIns.editEnabled = false
                thisIns.loadData()
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#timeshiftChannelDiv > .con-vs-loading')
            })
        },
        removeTimeshiftChannel() {
            const thisIns = this
            const removePromise = this.$http.delete('/api/management/v1/timeshift/' + this.$route.params.id)
            removePromise.then(function() {
                thisIns.$printSuccess('Timeshift channel removed')
                thisIns.$nextTick(() => {
                    thisIns.$router.push('/timeshift_channels')
                })
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            })
        },
    },
    mounted() {
        this.loadData()
    }
}
</script>
<style lang="scss" scoped>
.simple-table {
    td {
        vertical-align: top;
        min-width: 160px;
        padding-bottom: 1.3rem;
        word-break: break-all;

        @media screen and (max-width:370px) {
            display: block;
        }
    }
}

</style>
